import { call, put, takeEvery } from 'redux-saga/effects';
import {
  educationQualificationService,
  saveDegreeService,
  saveCertificateService,
  updateEducationQualificationService,
  updateDegreeService,
  updateCertificateService,
  deleteDegreeService,
  deleteCertificateService,
  getDegreeService,
  getCertificateService
} from '../../services/educationForm';
import * as type from '../ActionTypes';
const responseStatus = [200, 201, 204];
function* saveEducationQualification(action: any): any {
  try {
    const response = yield call(educationQualificationService, action.payload);
    if (responseStatus.includes(response?.statusCode)) {
      yield put({
        type: type.SAVE_EDUCATION_QUALIFICATION_SUCCESS,
        data: response?.data
      });
    } else {
      yield put({
        type: type?.SAVE_EDUCATION_QUALIFICATION_FAILURE,
        error: response?.data?.error[0]
      });
    }
  } catch (e: any) {
    yield put({ type: type?.SAVE_EDUCATION_QUALIFICATION_FAILURE, message: e.message });
  }
}

function* saveDegree(action: any): any {
  try {
    const response = yield call(saveDegreeService, action.payload);

    if (responseStatus.includes(response?.statusCode)) {
      yield put({
        type: type.SAVE_DEGREE_SUCCESS,
        data: response?.data
      });
    } else {
      yield put({ type: type?.SAVE_DEGREE_FAILURE, error: response?.data?.error[0] });
    }
  } catch (e: any) {
    yield put({ type: type?.SAVE_DEGREE_FAILURE, error: e.message });
  }
}

function* saveCertificate(action: any): any {
  try {
    const response = yield call(saveCertificateService, action.payload);
    if (responseStatus.includes(response?.statusCode)) {
      yield put({
        type: type.SAVE_CERTIFICATE_SUCCESS,
        data: response?.data
      });
    } else {
      yield put({ type: type?.SAVE_CERTIFICATE_FAILURE, error: response?.data?.error[0] });
    }
  } catch (e: any) {
    yield put({ type: type?.SAVE_CERTIFICATE_FAILURE, error: e.message });
  }
}
function* getDegree(): any {
  try {
    const response = yield call(getDegreeService);
    if (responseStatus.includes(response?.statusCode)) {
      yield put({
        type: type.GET_DEGREE_SUCCESS,
        data: response?.data?.results
      });
    } else {
      yield put({ type: type?.GET_DEGREE_FAILURE, error: response?.data?.error[0] });
    }
  } catch (e: any) {
    yield put({ type: type?.GET_DEGREE_FAILURE, error: e.message });
  }
}
function* getCertificate(): any {
  try {
    const response = yield call(getCertificateService);
    if (responseStatus.includes(response?.statusCode)) {
      yield put({
        type: type.GET_CERTIFICATE_SUCCESS,
        data: response?.data?.results
      });
    } else {
      yield put({ type: type?.GET_CERTIFICATE_FAILURE, error: response?.data?.error[0] });
    }
  } catch (e: any) {
    yield put({ type: type?.GET_CERTIFICATE_FAILURE, error: e.message });
  }
}
function* updateEducationQualification(action: any): any {
  try {
    const response = yield call(updateEducationQualificationService, action.payload, action.userId);
    if (responseStatus.includes(response?.statusCode)) {
      yield put({
        type: type.SAVE_EDUCATION_QUALIFICATION_SUCCESS,
        data: response?.data
      });
    } else {
      yield put({
        type: type?.SAVE_EDUCATION_QUALIFICATION_FAILURE,
        error: response?.data?.error[0]
      });
    }
  } catch (e: any) {
    yield put({ type: type?.SAVE_EDUCATION_QUALIFICATION_FAILURE, message: e.message });
  }
}

function* updateDegree(action: any): any {
  try {
    const response = yield call(updateDegreeService, action.payload, action.userId);
    if (responseStatus.includes(response?.statusCode)) {
      yield put({
        type: type.SAVE_DEGREE_SUCCESS,
        data: response?.data
      });
    } else {
      yield put({ type: type?.SAVE_DEGREE_FAILURE, error: response?.data?.error[0] });
    }
  } catch (e: any) {
    yield put({ type: type?.SAVE_DEGREE_FAILURE, error: e.message });
  }
}

function* updateCertificate(action: any): any {
  try {
    const response = yield call(updateCertificateService, action.payload, action.userId);
    if (responseStatus.includes(response?.statusCode)) {
      yield put({
        type: type.SAVE_CERTIFICATE_SUCCESS,
        data: response?.data
      });
    } else {
      yield put({ type: type?.SAVE_CERTIFICATE_FAILURE, error: response?.data?.error[0] });
    }
  } catch (e: any) {
    yield put({ type: type?.SAVE_CERTIFICATE_FAILURE, error: e.message });
  }
}

function* deleteDegree(action: any): any {
  try {
    const response = yield call(deleteDegreeService, action.userId);
    if (responseStatus.includes(response?.statusCode)) {
      yield put({
        type: type.DELETE_DEGREE_SUCCESS,
        message: response?.data?.messsage
      });
    } else {
      yield put({ type: type?.SAVE_DEGREE_FAILURE, error: response?.data?.error[0] });
    }
  } catch (e: any) {
    yield put({ type: type?.SAVE_DEGREE_FAILURE, error: e.message });
  }
}
function* deleteCertificate(action: any): any {
  try {
    const response = yield call(deleteCertificateService, action.userId);
    if (responseStatus.includes(response?.statusCode)) {
      yield put({
        type: type.DELETE_CERTIFICATE_SUCCESS,
        message: response?.data?.messsage
      });
    } else {
      yield put({ type: type?.SAVE_CERTIFICATE_FAILURE, error: response?.data?.error[0] });
    }
  } catch (e: any) {
    yield put({ type: type?.SAVE_CERTIFICATE_FAILURE, error: e.message });
  }
}
function* educationForm() {
  yield takeEvery(type?.SAVE_EDUCATION_QUALIFICATION, saveEducationQualification);
  yield takeEvery(type?.SAVE_DEGREE, saveDegree);
  yield takeEvery(type?.SAVE_CERTIFICATE, saveCertificate);
  yield takeEvery(type?.GET_DEGREE, getDegree);
  yield takeEvery(type?.GET_CERTIFICATE, getCertificate);
  yield takeEvery(type?.UPDATE_EDUCATION_QUALIFICATION, updateEducationQualification);
  yield takeEvery(type?.UPDATE_DEGREE, updateDegree);
  yield takeEvery(type?.UPDATE_CERTIFICATE, updateCertificate);
  yield takeEvery(type?.DELETE_DEGREE, deleteDegree);
  yield takeEvery(type?.DELETE_CERTIFICATE, deleteCertificate);
}

export default educationForm;
